import React from "react";
import { SizeGuideModal } from "../SizeGuideModal";

export const SizeSelector = ({ sizes, value, onChange }) => (
  <div className="mt-8">
    <div className="flex items-center justify-between mb-3">
      <span className="micro-label text-[#1a1814]/60">Size · Tall fit</span>
      <SizeGuideModal
        trigger={
          <button
            type="button"
            className="micro-label underline underline-offset-4 text-[#1a1814]/60 hover:text-[#1a1814]"
            data-testid="size-guide-btn"
          >
            Size guide
          </button>
        }
      />
    </div>
    <div className="grid grid-cols-5 gap-2">
      {sizes.map((s) => (
        <button
          type="button"
          key={s}
          onClick={() => onChange(s)}
          className={`py-3 micro-label border text-[10px] ${
            value === s ? "border-[#1a1814] bg-[#1a1814] text-[#f0e9e1]" : "border-[#1a1814]/20 hover:border-[#1a1814]"
          }`}
          data-testid={`size-option-${s}`}
        >
          {s}
        </button>
      ))}
    </div>
  </div>
);
